<form #boardForm="ngForm">
    <div class="row">

        <div class="col-sm-4">
            <select [ngModel]="boards.boardType" (ngModelChange)="boardChanged($event);boards.boardType=$event" required name="aux.{{index}}.boardType" type="text" class="form-control" id="aux-{{index}}-boardType">
            <option value="" disabled>---</option>
            <option *ngFor="let pT of selectedBoardTypes" [disabled]="!pT.selectable" value="{{pT.code}}">{{pT.short}} ({{pT.name}})</option>
          </select>
        </div>
        <div class="col-sm-3">
            <div class="input-group">
                <input class="form-control" currencyMask [(ngModel)]="boards.currencyMaskPrice" [options]="{ prefix: '', thousands: '.', decimal: ',', suffix: ' €' }" (ngModelChange)="displayCurrentValue($event)" name="price-one" />
            </div>
            <!-- <div class="input-group">
                <input [(ngModel)]="boards.priceForAdmin" required (change)="SetValueOfPrice(boards.priceForAdmin)" #price="price" name="aux.{{index}}.price" pattern="^(?:([+-]?\d+(\,)\d{2})|(\d+))$" #price="ngModel" type="text" class="form-control" id="aux-{{index}}-price">
                <span class="input-group-addon">
                &euro;
            </span>
            </div>
            <div *ngIf="price.invalid && (price.dirty || price.touched)" class="alert alert-danger">
                <div *ngIf="price.errors.required">
                    Must have one price
                </div>
                <div *ngIf="price.errors.pattern">
                    Must be in correct format
                </div>
            </div> -->
        </div>
        <div class="col-sm-2">

        </div>

        <div class="col-sm-1">
            <input [(ngModel)]="boards.active" name="aux.{{index}}.active" type="checkbox" class="form-control mt-3" id="aux-{{index}}-active">
        </div>

        <div class="col-sm-2 pt-2  text-center">
            <i class="fa fa-clone" style="cursor: pointer;" alt="Kopieren" title="{{'simple-travel-form.hint.copy.entry' | translate}}" (click)="copyAuxiliary(boards, index)"></i>
            <i class="fa fa-trash" style="cursor: pointer;" alt="Löschen" title="{{'simple-travel-form.hint.delete.entry' | translate}}" (click)="deleteAuxiliary(index, boards)"></i>
        </div>
    </div>
    <button hidden="true" (click)="sendForm(boardForm.valid)" id="board-{{index}}">TEST</button>
</form>


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-board-upgrades/simple-travel-form-board-upgrades.component.html